import { render, staticRenderFns } from "./TonnageZones.vue?vue&type=template&id=72135304&scoped=true&"
import script from "./TonnageZones.vue?vue&type=script&lang=js&"
export * from "./TonnageZones.vue?vue&type=script&lang=js&"
import style0 from "./TonnageZones.vue?vue&type=style&index=0&id=72135304&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72135304",
  null
  
)

export default component.exports